import { render, staticRenderFns } from "./ClaimAboutModals.vue?vue&type=template&id=43cbf9f5&scoped=true"
import script from "./ClaimAboutModals.vue?vue&type=script&lang=js"
export * from "./ClaimAboutModals.vue?vue&type=script&lang=js"
import style0 from "./ClaimAboutModals.vue?vue&type=style&index=0&id=43cbf9f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cbf9f5",
  null
  
)

export default component.exports